/* =====================================================================
   Quiz module — reusable on home page + /quiz.html
   Usage: mountQuiz('#quizContainer')
   ===================================================================== */
(function() {
  const QUESTIONS = [
    { k: 'who', q: "Who's it for?", opts: [
      { e: '👩', v: 'Mom' }, { e: '👨', v: 'Dad' },
      { e: '💑', v: 'Partner' }, { e: '👧', v: 'Sister' },
      { e: '👦', v: 'Brother' }, { e: '👶', v: 'Kid' },
      { e: '💼', v: 'Colleague' }, { e: '🤝', v: 'Friend' },
    ]},
    { k: 'occ', q: "What's the occasion?", opts: [
      { e: '🎂', v: 'Birthday' }, { e: '💍', v: 'Anniversary' },
      { e: '🪔', v: 'Diwali' }, { e: '🎗️', v: 'Rakhi' },
      { e: '💝', v: "Valentine's" }, { e: '🎓', v: 'Achievement' },
      { e: '🏠', v: 'Housewarming' }, { e: '💫', v: 'Just because' },
    ]},
    { k: 'vibe', q: 'Their vibe?', opts: [
      { e: '🏠', v: 'Cozy homebody' }, { e: '✨', v: 'Self-care obsessed' },
      { e: '☕', v: 'Foodie' }, { e: '💪', v: 'Always-on-the-move' },
      { e: '💕', v: 'Romantic' }, { e: '🎨', v: 'Creative' },
    ]},
    { k: 'budget', q: "What's your budget?", opts: [
      { e: '💰', v: 'Under ₹499' }, { e: '💎', v: '₹500–999' },
      { e: '👑', v: '₹1,000–2,499' }, { e: '🚀', v: '₹2,500+' },
    ]},
  ];

  const PRODUCTS = [
    { id: 'p01', name: 'The Cozy Hamper', price: 1299, mrp: 1999, tags: ['Cozy homebody', 'Mom', 'Birthday', 'Diwali'] },
    { id: 'p02', name: 'Love Letter Set', price: 899, mrp: 1299, tags: ['Partner', 'Romantic', 'Anniversary', "Valentine's"] },
    { id: 'p03', name: 'Hand-poured Candle Trio', price: 749, mrp: 1199, tags: ['Self-care obsessed', 'Cozy homebody', 'Housewarming', 'Just because'] },
    { id: 'p04', name: 'Anniversary Keepsake Box', price: 1899, mrp: 2499, tags: ['Partner', 'Romantic', 'Anniversary'] },
    { id: 'p05', name: 'Chai & Cookies Bundle', price: 599, mrp: 799, tags: ['Foodie', 'Dad', 'Friend', 'Just because'] },
    { id: 'p06', name: 'Desk Refresh Set', price: 999, mrp: 1499, tags: ['Always-on-the-move', 'Colleague', 'Achievement'] },
    { id: 'p07', name: 'Sister Self-care Box', price: 1299, mrp: 1799, tags: ['Self-care obsessed', 'Sister', 'Birthday'] },
    { id: 'p08', name: "Little One's Keepsake", price: 1499, mrp: 1999, tags: ['Kid', 'Creative', 'Birthday'] },
    { id: 'p09', name: 'Coffee Ritual Set', price: 1799, mrp: 2499, tags: ['Foodie', 'Partner', 'Brother', 'Achievement'] },
    { id: 'p10', name: 'Rakhi Thali Premium', price: 1199, mrp: 1699, tags: ['Brother', 'Rakhi'] },
    { id: 'p11', name: 'Diwali Lights & Sweets', price: 899, mrp: 1299, tags: ['Mom', 'Dad', 'Diwali'] },
    { id: 'p12', name: 'Small Joy Mini', price: 449, mrp: 649, tags: ['Friend', 'Just because', 'Colleague'] },
  ];

  const inBudget = (p, b) => {
    if (b === 'Under ₹499') return p.price < 500;
    if (b === '₹500–999') return p.price >= 500 && p.price < 1000;
    if (b === '₹1,000–2,499') return p.price >= 1000 && p.price < 2500;
    if (b === '₹2,500+') return p.price >= 2500;
    return true;
  };

  window.mountQuiz = function(selector) {
    const card = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!card) return;

    let step = 0;
    const answers = {};

    function render() {
      if (step < QUESTIONS.length) {
        const q = QUESTIONS[step];
        const pct = Math.round(((step) / QUESTIONS.length) * 100);
        card.innerHTML = `
          <div class="qzv2">
            <div class="qzv2-progress-wrap">
              <div class="qzv2-progress-label">
                <span class="qzv2-step">Q${step + 1}/${QUESTIONS.length}</span>
                <span class="qzv2-pct">${pct}%</span>
              </div>
              <div class="qzv2-progress-bar"><div class="qzv2-progress-fill" style="width:${pct}%"></div></div>
            </div>
            <h2 class="qzv2-q">${q.q}</h2>
            <div class="qzv2-grid">
              ${q.opts.map((o, i) => `
                <button class="qzv2-tile qzv2-tile-c${i % 4}" data-v="${o.v}">
                  <span class="qzv2-emoji">${o.e}</span>
                  <span class="qzv2-label">${o.v}</span>
                </button>
              `).join('')}
            </div>
            ${step > 0 ? '<button class="qzv2-back" data-back>← Back</button>' : ''}
          </div>
        `;
        card.querySelectorAll('button[data-v]').forEach(b => b.addEventListener('click', () => {
          b.classList.add('qzv2-picked');
          setTimeout(() => {
            answers[q.k] = b.dataset.v;
            step++;
            render();
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 180);
        }));
        const backBtn = card.querySelector('[data-back]');
        if (backBtn) backBtn.addEventListener('click', () => { step = Math.max(0, step - 1); render(); });
      } else {
        const { who, occ, vibe, budget } = answers;
        const filtered = PRODUCTS.filter(p => inBudget(p, budget));
        const scored = filtered.map(p => ({
          ...p,
          score: (p.tags.includes(who) ? 3 : 0) + (p.tags.includes(occ) ? 3 : 0) + (p.tags.includes(vibe) ? 2 : 0)
        })).sort((a,b) => b.score - a.score);
        const top = scored.slice(0, 6);
        const bundleTotal = top.slice(0, 3).reduce((s,p) => s + p.price, 0);

        card.innerHTML = `
          <div class="quiz-result">
            <div class="quiz-result-head">
              <div class="quiz-step-label">✨ Your top picks</div>
              <h2 style="margin-top: 10px;">Top ${top.length} picks for<br><em>${who}'s ${occ.toLowerCase()}</em></h2>
              <p style="margin-top: 10px; color: var(--ink-soft);">Based on: ${vibe} · ${budget}</p>
            </div>

            <div class="product-grid">
              ${top.map(p => `
                <a href="product.html" class="product-card">
                  <div class="thumb"><img src="${(window.WTG_IMAGES && window.WTG_IMAGES[p.id]) || ''}" alt="${p.name}" loading="lazy"></div>
                  <div class="meta">
                    <h4>${p.name}</h4>
                    <div class="rating"><span class="star">★</span> 4.7</div>
                    <div class="price-row"><span class="price">₹${p.price.toLocaleString('en-IN')}</span><span class="mrp">₹${p.mrp.toLocaleString('en-IN')}</span></div>
                    <div class="save">You save ₹${(p.mrp - p.price).toLocaleString('en-IN')}</div>
                  </div>
                </a>
              `).join('')}
            </div>

            <div class="quiz-result-cta mt-6">
              <div class="qrc-text">
                <h3>Add top 3 to cart</h3>
                <p style="margin-top: 4px; opacity: 0.85; font-size: 14px;">Subtotal: ₹${bundleTotal.toLocaleString('en-IN')} · Save ₹200 when bundled</p>
              </div>
              <button class="btn btn-accent" data-add-all>Add all 3 → Cart</button>
              <button class="btn" style="background: transparent; color: #fff; border: 1px solid rgba(255,255,255,0.4);" data-restart>Start over</button>
            </div>
          </div>
        `;
        card.querySelector('[data-restart]').addEventListener('click', () => { step = 0; for (const k in answers) delete answers[k]; render(); card.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        card.querySelector('[data-add-all]').addEventListener('click', () => {
          top.slice(0, 3).forEach(p => window.Cart && Cart.add({ id: p.id, name: p.name, price: p.price, mrp: p.mrp, variant: 'default' }));
          if (window.toast) toast('Added 3 gifts to bag ✿');
          setTimeout(() => window.location.href = 'cart.html', 800);
        });
      }
    }
    render();
  };
})();
